import { Spinner } from 'cpool-components/state/Spinner';
import { SpinnerSize } from 'cpool-components/state/Spinner/types';
import { useTranslation } from 'react-i18next';
import { LuCircleX, LuFileText } from 'react-icons/lu';

type Props = {
    name: string;
    progress: number;
    onCancel: () => void;
};

export const UploadProgressRow: React.FC<Props> = ({ name, onCancel, progress }) => {
    const { t } = useTranslation();
    // Once the body is fully sent the upload can no longer be rolled back client-side.
    const isProcessing = progress >= 100;

    return (
        <div className="rounded-md border border-grey-outline-light px-3 py-2">
            <div className="flex items-center gap-2 text-sm text-midnight">
                <LuFileText size={16} className="shrink-0 text-midnight-placeholder" />
                <span className="truncate">{name}</span>
                <span className="ml-auto flex items-center gap-1.5 whitespace-nowrap text-xs text-midnight-placeholder">
                    <Spinner size={SpinnerSize.SMALL} />
                    {t(isProcessing ? 'FILE_UPLOAD.PROCESSING' : 'FILE_UPLOAD.UPLOADING')}
                </span>
                <button
                    type="button"
                    aria-label={t('FILE_UPLOAD.CANCEL_UPLOAD')}
                    className="shrink-0 text-midnight"
                    disabled={isProcessing}
                    onClick={onCancel}
                >
                    <LuCircleX size={16} />
                </button>
            </div>
            <div className="mt-2 flex items-center gap-2">
                <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-grey-outline-light">
                    {/* Width is data-driven, so it has to be an inline style rather than a utility class. */}
                    <div
                        className="h-full rounded-full bg-midnight transition-[width]"
                        style={{ width: `${progress}%` }}
                    />
                </div>
                <span className="w-10 shrink-0 text-right text-xs text-midnight-placeholder">{progress} %</span>
            </div>
        </div>
    );
};
